export default "__VITE_ASSET__Q6$_y0ZC__"